<template>
  <div
    class="banner-wrapper"
    :class="`${experienceType === getMerch ? 'merch-background-color' : 'design-background-color'}`"
  >
    <div class="table-shadow"></div>
    <div
      class="background-container background-container-left"
      :class="`${experienceType === getMerch ? 'left-side-merch' : 'left-side-design'}`"
    ></div>
    <div
      class="background-container background-container-right"
      :class="`${experienceType === getMerch ? 'right-side-merch' : 'right-side-design'}`"
    ></div>
    <div class="banner-content">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'HeroBanner',
  props: {
    experienceType: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('experience', ['getMerch']),
    ...mapGetters('experience', ['getDesign'])
  }
};
</script>

<style lang="scss" scoped>
.banner-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 544px;
  width: 100vw;
  overflow: unset;
  &.merch-background-color {
    background-color: $homeMerch;
  }
  &.design-background-color {
    background-color: $homeDesign;
  }
  @include xl2 {
    min-height: 380px;
  }
  @include md {
    min-height: 300px;
  }
  @include sm {
    min-height: 260px;
  }
  .table-shadow {
    height: 22%;
    width: 100%;
    position: absolute;
    bottom: 0px;
    box-shadow: 0px -10px 80px 0px rgba(255, 255, 255, 0.1);
    background: #00000010;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.15) 80%);
  }
  .background-container {
    position: absolute;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 30%;
    width: 35%;
  }
  .background-container-left {
    background-position: left;
    left: 0px;
    &.left-side-merch {
      background-image: url('https://cdn.vexels.com/img/merchhome.png?fmt=webp');
    }
    &.left-side-design {
      background-image: url('https://cdn.vexels.com/img/designhome-left.png?fmt=webp');
    }
    @include xl3 {
      left: -100px;
    }
    @include xl2 {
      background-position: -40px;
      left: 0px;
    }
    @include xl {
      background-position: -100px;
    }
    @include lg {
      background-position: -140px;
      display: none;
    }
  }
  .background-container-right {
    right: 0px;
    background-position: right;
    &.right-side-merch {
      width: 40%;
      background-image: url('https://cdn.vexels.com/img/merchhome-right.png?fmt=webp');
    }
    &.right-side-design {
      width: 40%;
      background-image: url('https://cdn.vexels.com/img/designhome.png?fmt=webp');
    }
    @include xl3 {
      right: -100px;
    }
    @include xl2 {
      background-position: calc(100% + 40px);
      right: 0px;
    }
    @include xl {
      background-position: calc(100% + 80px);
    }
    @include lg {
      background-position: calc(100% + 120px);
      display: none;
    }
  }
  .banner-content {
    width: 33vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1;
    @include xl2 {
      width: 40vw;
    }
    @include xl {
      width: 45vw;
    }
    @include lg {
      width: 60vw;
    }
    @include md {
      width: 80vw;
    }
  }
}
</style>
